import React from 'react'
import { RouteComponentProps } from 'react-router'
import { Route, Switch } from 'react-router-dom'
import AccountChecking from './account-checking/account-checking'
import DataView from './data-view/data-view'
import GoodSale from './good-sale/good-sale'
import MemberData from './member-data/member-data'

const path = '/main/data'

export const ACCOUNT_CHECKING = path + '/accountChecking'
export const GOODS_SALE_CHART = path + '/goodsSale'
export const DATA_VIEW = path + '/dataView'
export const MEMBER_DATA = path + '/memberData'

export default (props: RouteComponentProps) => {
    return (
        <Switch>
            <Route path={props.match.path + '/accountChecking'} component={AccountChecking}></Route>
            <Route path={props.match.path + '/goodsSale'} component={GoodSale}></Route>
            <Route path={props.match.path + '/dataView'} component={DataView}></Route>
            <Route path={props.match.path + '/memberData'} component={MemberData}></Route>
        </Switch>
    )
}
